module.exports = __webpack_public_path__ + "img/img_0.c6b48c84.png";